import "react-datepicker/dist/react-datepicker.css";
import { Button } from "../../Button";
import { PropTypes } from "prop-types";
import SimpleSearch from "../../SimpleSearch";
import { useEffect, useState } from "react";
import { StyledUserSearchActions, StyledUserSearchOptions } from "../../../styles/StyledUserSearch/StyledUsearSearch";
import { Checkbox } from "../../Checkbox";
import { useQuery } from "react-query";
import { QueryLoader } from "../../Loader";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function SelectableMultipleUnits({ id, choosenUnits, setChoosenUnits, fetchUnits, children, name }) {
	const { axiosPrivate } = useAxiosPrivate();

	const [phrase, setPhrase] = useState(null);
	const { isLoading, isError, error, data } = useQuery([`membersUnitsTab${name}`, phrase, id, name], () =>
		fetchUnits(axiosPrivate, phrase, id)
	);
	const [resultData, setResultData] = useState([]);

	const [isChoosen, setIsChoosen] = useState(false);

	useEffect(() => {
		if (!isLoading && !isError) {
			const tempChoosenUnits = {};
			for (const item of data) {
				tempChoosenUnits[item.id] = false;
			}
			setChoosenUnits({ ...tempChoosenUnits, ...choosenUnits });
			setResultData(data);
			let tempIsChoosen = false;
			Object.keys(choosenUnits).map((key) => {
				if (key) tempIsChoosen = true;
			});
			setIsChoosen(tempIsChoosen);
		} else if (isError) {
			console.log(error);
		}
	}, [isLoading, data]);

	return (
		<>
			<StyledUserSearchOptions>
				<SimpleSearch isWhite setPhrase={setPhrase} value={phrase} />
				<Button
					onClick={() => {
						setPhrase(null);
					}}
					bg={false}
					small={true}
				>
					Clear filters
				</Button>
			</StyledUserSearchOptions>
			{isLoading || isError ? (
				<QueryLoader />
			) : (
				<StyledUserSearchActions>
					<div className="items">
						{resultData.map((e, i) => {
							if (!choosenUnits[e.id])
								return (
									<label className="item" key={i} htmlFor={`choosePerson-${i}`}>
										<Checkbox
											name={`choosePerson-${i}`}
											changeHandler={() => {
												setChoosenUnits({ ...choosenUnits, [e.id]: e });
												let isAdded = false;
												for (const key in choosenUnits) {
													if (choosenUnits[key] || !choosenUnits[e.id]) isAdded = true;
												}
												setIsChoosen(isAdded);
											}}
											value={choosenUnits[e.id] ? true : false}
										/>
										{e.name}
									</label>
								);
						})}
					</div>
					{isChoosen ? (
						<div className="items items--choosen">
							{Object.keys(choosenUnits).map((key, i) => {
								const e = choosenUnits[key];
								if (e)
									return (
										<label className="item" key={i} htmlFor={`choosenPerson-${i}`}>
											<Checkbox
												name={`choosenPerson-${i}`}
												changeHandler={() => {
													const res = { ...choosenUnits, [e.id]: false };
													setChoosenUnits({ ...choosenUnits, [e.id]: false });
													let isAdded = false;
													for (const key in res) {
														if (res[key]) isAdded = true;
													}
													setIsChoosen(isAdded);
												}}
												value={choosenUnits[e.id] ? true : false}
											/>
											{e.name}
										</label>
									);
							})}
						</div>
					) : (
						""
					)}
					{children && children}
				</StyledUserSearchActions>
			)}
		</>
	);
}

SelectableMultipleUnits.propTypes = {
	refetch: PropTypes.func,
	fetchUnits: PropTypes.func,
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	choosenUnits: PropTypes.any,
	setChoosenUnits: PropTypes.any,
	children: PropTypes.any,
	name: PropTypes.any,
};
